module.exports = __webpack_public_path__ + "static/media/twin.dad9ee8d.png";